import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { AuthProvider } from "@/auth/AuthProvider";
import { ToastProvider } from "@/components/Toast";
import { AppVersionContext, VersionCheck } from "@/components/VersionCheck";
import { theme } from "@/theme/theme";
import { queryClient } from "./queryClient";
import { router } from "./router";

export function App({ version }: { version: string }) {
  return (
    <ThemeProvider theme={theme} defaultMode="light">
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AppVersionContext.Provider value={version}>
          <AuthProvider>
            <ToastProvider>
              <RouterProvider router={router} />
              <VersionCheck clientVersion={version} />
            </ToastProvider>
          </AuthProvider>
        </AppVersionContext.Provider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
